import { FC, memo, useState } from 'react';
import NoPhotoIcon from '@icons/no_photo_icon.svg?component';
import { IEntityIconProps } from './types';

export const EntityIcon: FC<IEntityIconProps> = ({ src, name, size = 32, id, styleProp }) => {
  const [isImg, setIsImg] = useState(!!src);

  return (
    <div
      className={`flex-centred rounded-[8px] overflow-hidden border border-primary bg-white ${
        !isImg && 'bg-bg-color border-custom-gray'
      } ${styleProp}`}
      style={{ height: size, width: size }}
      id={id}
    >
      {isImg ? (
        <img
          src={src || ''}
          width={size}
          height={size}
          alt={name}
          id={id + 'Icon'}
          loading="lazy"
          onError={() => {
            setIsImg(false);
          }}
        />
      ) : (
        <NoPhotoIcon id={id + 'Icon'} className="" width={20} height={20} />
      )}
    </div>
  );
};
